// Auth0 Guide
// https://developer.auth0.com/resources/guides/spa/react/basic-authentication

import { Auth0Provider } from "@auth0/auth0-react";
import React from "react";

import { KonsolScopes } from "./scopes";

export const KonsolAuth0Provider = ({ children }) => {


  if (!(process.env.REACT_APP_AUTH0_DOMAIN 
    && process.env.REACT_APP_AUTH0_CLIENT_ID 
    && process.env.REACT_APP_AUTH0_REDIRECT_URI 
    && process.env.REACT_APP_AUTH0_AUDIENCE)) {
    return null;
  }

  return (
    <Auth0Provider
      domain={process.env.REACT_APP_AUTH0_DOMAIN}
      clientId={process.env.REACT_APP_AUTH0_CLIENT_ID}
      useRefreshTokens={true}
      useRefreshTokensFallback={true}
      cacheLocation="memory"
      authorizationParams={{
        redirect_uri: process.env.REACT_APP_AUTH0_REDIRECT_URI,
        audience: process.env.REACT_APP_AUTH0_AUDIENCE,
        scope: `offline_access profile ${KonsolScopes}`,
      }}
    >
      {children}
    </Auth0Provider>
  );
};